import * as React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

interface IProps {
  text: string;
}

const IconWrapper = styled.div`
  display: inline-block;
  margin-left: 0.3em;
  line-height: 0;
`;

export class HelpTip extends React.Component<IProps, {}> {
  public render() {
    const tooltipInner = (
      <div style={{ padding: '10px', fontSize: '1rem', textAlign: 'left', fontWeight: 700 }}>{this.props.text}</div>
    );
    return (
      <Tooltip html={tooltipInner}>
        <IconWrapper>
          <kz-icon-help-circle size={'1em'} />
        </IconWrapper>
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/HelpTip.tsx